<template>
	<el-container class="Wrapper">
		<el-container class="capital-container">
			<el-main class="mainx">
				<el-header class="search" style="margin-top: 9vh;">
					<el-form :model="queryParam" :inline="true">
						<el-form-item label="时间段">
							<el-date-picker v-model="queryParam.dateArr" type="daterange" start-placeholder="起始日期"
								end-placeholder="截止日期" value-format="YYYY-MM-DD" :default-time="defaultTime" />
						</el-form-item>
						<el-form-item label="状态">
							<el-radio-group v-model="queryParam.payStatus">
								<el-radio value="1" label="已支付"></el-radio>
								<el-radio value="2" label="未支付"></el-radio>
							</el-radio-group>
						</el-form-item>
						<!-- 按钮 -->
						<el-form-item>
							<el-button type="primary" @click="getData()">查询</el-button>
							<!-- <el-button>重置</el-button> -->
							<el-button @click="exportData()">导出</el-button>
						</el-form-item>
					</el-form>
				</el-header>
				<el-main class="content-main">
					<div class="statisticsData">
						时间段：{{ queryParam.dateArr }} 订单数量：{{ orderTotal }} 订单总额：{{ orderMoney }}
					</div>
					<div class="lists">
						<el-table :data="dataList" style="width: 95%;overflow: auto;" height="500" v-loading="loading" border
							element-loading-text="加载中，请稍后...">
							<el-table-column prop="wxUserId" label="用户ID" />
							<!-- <el-table-column prop="nickName" label="用户昵称"/> -->
							<el-table-column prop="orderPrice" width="100px" label="金额" />
							<el-table-column prop="addOrderTime" label="订单创建时间" />
							<el-table-column prop="" label="订单状态">
								<template #default="scope">
									<span v-if="scope.row.orderStatus === 0"> <el-tag type="primary">未支付</el-tag></span>
									<span v-if="scope.row.orderStatus == 1"><el-tag type="success">已支付</el-tag></span>
									<span v-if="scope.row.orderStatus == 2"><el-tag type="danger">待发货</el-tag></span>
									<span v-if="scope.row.orderStatus == 3"><el-tag type="primary">待收货</el-tag></span>
									<span v-if="scope.row.orderStatus == 5"><el-tag type="info">已退款</el-tag></span>
									<span v-if="scope.row.orderStatus == 6"><el-tag type="warning">申请退款</el-tag></span>
									<span v-if="scope.row.orderStatus == 4"><el-tag type="success">已完成</el-tag></span>
								</template>
							</el-table-column>
							<!-- <el-table-column prop="name" label="类型" /> -->
							<el-table-column prop="storeName" label="商品门店" />
							<el-table-column prop="id" label="订单号" min-width="130" />
							<el-table-column prop="goodsName" label="商品名称" />
							<el-table-column prop="goodsNumber" label="数量" />
							<!-- <el-table-column prop="" label="支付单号"  /> -->
							<!-- <el-table-column prop="" label="支付时间"  /> -->
						</el-table>
					</div>
				</el-main>
				<el-footer class="pagination">
					<el-pagination class="juzhong" v-model:current-page="pagination.current"
						v-model:page-size="pagination.pageSize" @size-change="getData()" @current-change="getData()"
						small :page-sizes="[20, 30, 50,100]" layout="total, sizes, prev, pager, next, jumper"
						:total="orderTotal">
					</el-pagination>
				</el-footer>
			</el-main>
		</el-container></el-container>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router'
import { ref, toRaw, reactive } from 'vue'
import instance from '../network/storester.js'
import { ElMessage, ElMessageBox } from 'element-plus'

const queryParam = reactive({
	dateArr: '',
	payStatus: '已支付',
	address:'',
	category:''
})
const defaultTime = ref < [Date, Date] > ([
	new Date(),
	new Date(),
])
const pagination = ref({
	current: 1,
	pageSize: 20

})
const dataList = ref()
const loading = ref(true)
const orderMoney = ref()
const orderTotal = ref()

const getData = () => {
	console.log(queryParam.payStatus)
	var datas = {
		addOrderTimeBegin: queryParam.dateArr[0],
		addOrderTimeEnd: queryParam.dateArr[1],
		orderStatus2: queryParam.payStatus == '已支付' ? ['1', '2', '3', '4'] : ['0', '5', '6'],
		pageNum: pagination.value.current,
		pageSize: pagination.value.pageSize,
		storeId: localStorage.getItem("sysStoreId"),
		isTotal: true //是否要计算汇总金额
	}
	if (localStorage.getItem("permissionsStatus") === "0") {
		const { storeId, ...rest } = datas;
		datas = rest;
	}
	instance.post("/api/orders/list", datas).then((res) => {
		dataList.value = res.data.data.dataList;
		// orderser.value = toRaw(orderse.value);
		orderTotal.value = res.data.data.total;
		orderMoney.value = res.data.data.jine;
		pagination.value.current = res.data.data.current;
		pagination.value.pageSize = res.data.data.size;
		loading.value = false;
	})
		.catch((error) => {
			ElMessage({
				message: "请重新登录",
				type: "error",
			});
		});
}
getData();

const exportData = () => {
	var datas = {
		addOrderTimeBegin: queryParam.dateArr[0],
		addOrderTimeEnd: queryParam.dateArr[1],
		orderStatus2: queryParam.payStatus == '1' ? ['1', '2', '3', '4'] : ['0', '5', '6'],
		storeId: localStorage.getItem("sysStoreId")
	}
	if (localStorage.getItem("permissionsStatus") === "0") {
		const { storeId, ...rest } = datas;
		datas = rest;
	}
	instance.post("/api/orders/export", datas, { responseType: "blob" }).then((res) => {
		const url = window.URL.createObjectURL(new Blob([res.data]));
		const link = document.createElement("a");
		link.href = url;
		link.setAttribute("download", "订单流水.xlsx");
		document.body.appendChild(link);
		link.click();
		window.URL.revokeObjectURL(url);
		ElMessage({
			message: "导出成功",
			type: "success",
		});
	})
		.catch((error) => {
			console.log(error)
			ElMessage({
				message: "请重新登录",
				type: "error",
			});
		});
}
</script>

<style>
.capital-container {
	position: fixed;
	left: 12vw;
	width: 80vw;
	/* height: 90vh; */
	bottom: 10px;
}

.search {
	margin-top: 70px;
}

.content-main {
	position: fixed;
	padding: 10px;
	height: 70vh;
	overflow: hidden;
	z-index: 11;
}
.statisticsData{
	position: fixed;
	height: 24px;
	z-index: 12;
}

.lists {
	position: fixed;
	width: 90.5vw;
	height: calc(70vh - 30px);
	margin-top: 30px;
	overflow: hidden;
	z-index: 13;
}

.pagination {
	padding-top: 5px;
	text-align: center;
	height: 30px;
	width: 85vw;
	position: fixed;
	z-index: 15;
	bottom: 100px;
}

.mainx {
	position: fixed;
	top: 0;
	left: 11vw;
}
</style>